// Code generated by protoc-gen-ts. DO NOT EDIT.
// protoc-gen-ts is an Art Processors production, found in mos-sdk-py.

import { Release } from "generated/mos/org/getty/publish";
import { BundleType, BundleTypeValues } from "generated/mos/releasecontrols";
import { Codec, DecodeContext, RemoteObject, WebRPCError, ensureScalar, ensureScalarRepeated } from "generated/webrpc";

export namespace CreateReleaseRequest {
  export const refName = "mos.org.getty.publish_management.CreateReleaseRequest" as const;
  export type Entity = {
    readonly type: typeof refName,
    readonly bundleTypesToPublish: ReadonlyArray<BundleType>,
    readonly releaseNotes: string,
  }
  export const defaults: Entity = {
    type: refName,
    bundleTypesToPublish: [],
    releaseNotes: "",
  }
  export const codec: Codec<Entity> = new class {
    public encode(v: Entity): RemoteObject;
    public encode(v: Entity | undefined): RemoteObject | null {
      if (!v) return null;
      const { type, ...out } = v;
      return out;
    }
    public decode(v: RemoteObject): Entity;
    public decode(v: RemoteObject | null, ctx?: DecodeContext): Entity | undefined {
      if (v === undefined || v === null) return undefined;
      if (!ctx) ctx = new DecodeContext(".mos.org.getty.publish_management.CreateReleaseRequest");
      if (typeof(v) !== "object") throw ctx.expected("object", v);
      const out: RemoteObject = { ...defaults };
      {
        const evs = ensureScalarRepeated(ctx, v["bundleTypesToPublish"], "string").map(i => i || defaults["bundleTypesToPublish"]);
        for (const ev of evs) {
          if (!BundleTypeValues.has(ev as any)) {
            throw ctx.error(`unknown value "${ev}" for enum .mos.release_controls.BundleType`);
          }
        }
        out["bundleTypesToPublish"] = evs as any;
      }
      out["releaseNotes"] = ensureScalar(ctx, v["releaseNotes"], "string");
      return out as any as Entity;
    }
  }();
}

export namespace CreateReleaseResponse {
  export const refName = "mos.org.getty.publish_management.CreateReleaseResponse" as const;
  export type Entity = {
    readonly type: typeof refName,
    readonly status: CreateReleaseResponse.RequestStatus,
    readonly release: Release.Entity | undefined,
  }
  export const defaults: Entity = {
    type: refName,
    status: "OK",
    release: undefined,
  }
  export const codec: Codec<Entity> = new class {
    public encode(v: Entity): RemoteObject;
    public encode(v: Entity | undefined): RemoteObject | null {
      if (!v) return null;
      const obj: RemoteObject = {};
      obj["status"] = v.status;
      obj["release"] = Release.codec.encode(v.release);
      return obj;
    }
    public decode(v: RemoteObject): Entity;
    public decode(v: RemoteObject | null, ctx?: DecodeContext): Entity | undefined {
      if (v === undefined || v === null) return undefined;
      if (!ctx) ctx = new DecodeContext(".mos.org.getty.publish_management.CreateReleaseResponse");
      if (typeof(v) !== "object") throw ctx.expected("object", v);
      const out: RemoteObject = { ...defaults };
      {
        const ev = ensureScalar(ctx, v["status"], "string") || defaults["status"];
        if (!CreateReleaseResponse.RequestStatusValues.has(ev as any)) {
          throw ctx.error(`unknown value "${ev}" for enum .mos.org.getty.publish_management.CreateReleaseResponse.RequestStatus`);
        }
        out["status"] = ev as any;
      }
      out["release"] = ctx.decode(Release.codec, v["release"], "release");
      return out as any as Entity;
    }
  }();
  export const RequestStatusValues = new Set([
    'OK' as const,
    'ERROR_PUBLISH_ALREADY_IN_PROGRESS' as const,
    'ERROR_PUBLIC_BUNDLE_HAS_OUTSTANDING_ISSUES' as const,
  ]);
  export type RequestStatus = typeof RequestStatusValues extends Set<infer U> ? U : never;

}

